import { render, staticRenderFns } from "./pageInfo.vue?vue&type=template&id=3504a89a&"
import script from "./pageInfo.vue?vue&type=script&lang=js&"
export * from "./pageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports